import * as React from 'react';
import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import { useSelector } from 'react-redux';

import { AddOffer, Recommendations } from '../../components/Recommendations';
import { RealtorDemandContainer } from './containers/RealtorDemandContainer';
import { defaultRefWrapper } from '../Scrolling';
import { useTrackRealtorDemand } from './utils';
import { trackAddOfferClick, trackAddOfferVisible } from './tracking';
import { selectPageType } from '../../selectors/page';
import { useAddOfferTitle } from './utils/useAddOfferTitle';
import { VIEWED_TIMEOUT } from '../../constants/viewedBlock';

export function RecommendationsContainer() {
  const { trackDemandViewed } = useTrackRealtorDemand();
  const page = useSelector(selectPageType);
  const addOfferTitle = useAddOfferTitle();

  return (
    <Recommendations
      addForm={
        <ActionAfterViewObserver callback={trackAddOfferVisible} wrapper={false} callbackDelay={VIEWED_TIMEOUT}>
          <AddOffer title={addOfferTitle} onActionClick={() => trackAddOfferClick(page)} />
        </ActionAfterViewObserver>
      }
      demandRequest={
        <ActionAfterViewObserver callback={trackDemandViewed} wrapper={false} callbackDelay={VIEWED_TIMEOUT}>
          <RealtorDemandContainer />
        </ActionAfterViewObserver>
      }
    />
  );
}

RecommendationsContainer.defaultProps = {
  refWrapper: defaultRefWrapper,
};
